import {
  GET_DEFAULT_PROMPT_REQUEST,
  GET_DEFAULT_PROMPT_SUCCESS,
  GET_DEFAULT_PROMPT_FAILURE,
  CHANGE_DEFAULT_AGENT_PROMPT_REQUEST,
  CHANGE_DEFAULT_AGENT_PROMPT_SUCCESS,
  CHANGE_DEFAULT_AGENT_PROMPT_FAILURE,
  SAVE_GLOBAL_PROMPT_REQUEST,
  SAVE_GLOBAL_PROMPT_SUCCESS,
  SAVE_GLOBAL_PROMPT_FAILURE,
} from '../actions/defaultPromptActions';

const initialState = {
  prompt: {
    loading: false,
    error: null,
    data: null,
  },
  save: {
    loading: false,
    error: null,
    data: null,
    lastSavedAt: null,
  },
  globalPrompt: {
    loading: false,
    error: null,
    data: null,
    lastSavedAt: null,
  },
};

export default function defaultPrompt(state = initialState, action) {
  switch (action.type) {
    case GET_DEFAULT_PROMPT_REQUEST:
      return {
        ...state,
        prompt: { loading: true, error: null, data: null },
      };
    case GET_DEFAULT_PROMPT_SUCCESS:
      return {
        ...state,
        prompt: { loading: false, error: null, data: action.payload },
      };
    case GET_DEFAULT_PROMPT_FAILURE:
      return {
        ...state,
        prompt: { loading: false, error: action.error, data: null },
      };

    case CHANGE_DEFAULT_AGENT_PROMPT_REQUEST:
      return {
        ...state,
        save: { ...state.save, loading: true, error: null },
      };
    case CHANGE_DEFAULT_AGENT_PROMPT_SUCCESS:
      return {
        ...state,
        save: { loading: false, error: null, data: action.payload, lastSavedAt: Date.now() },
      };
    case CHANGE_DEFAULT_AGENT_PROMPT_FAILURE:
      return {
        ...state,
        save: { ...state.save, loading: false, error: action.error },
      };

    case SAVE_GLOBAL_PROMPT_REQUEST:
      return {
        ...state,
        globalPrompt: { ...state.globalPrompt, loading: true, error: null },
      };
    case SAVE_GLOBAL_PROMPT_SUCCESS:
      return {
        ...state,
        globalPrompt: { loading: false, error: null, data: action.payload, lastSavedAt: Date.now() },
      };
    case SAVE_GLOBAL_PROMPT_FAILURE:
      return {
        ...state,
        globalPrompt: { ...state.globalPrompt, loading: false, error: action.error },
      };

    default:
      return state;
  }
}
